import type {
  PushSentListApiData,
  PushSentListApiResponses,
  PushTestSendApiData,
  PushTestSendApiResponses,
  PushTokenRegisterApiData,
  PushTokenRegisterApiResponses,
  WorkerPushStatusListApiData,
  WorkerPushStatusListApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getNotificationUrls = {
  postRegisterPushToken: responseEndpoint<PushTokenRegisterApiData, PushTokenRegisterApiResponses>({
    getUrl: () => apiUrl('push-tokens/'),
    getBody: (data) => data
  }),
  getWorkerPushStatuses: dataEndpoint<WorkerPushStatusListApiData, WorkerPushStatusListApiResponses>({
    getUrl: (queryParams) => apiUrl('push-test/workers/', queryParams)
  }),
  getSentPushes: dataEndpoint<PushSentListApiData, PushSentListApiResponses>({
    getUrl: (queryParams) => apiUrl('push-test/sent/', queryParams)
  }),
  postSendTestPush: responseEndpoint<PushTestSendApiData, PushTestSendApiResponses>({
    getUrl: () => apiUrl('push-test/send/'),
    getBody: (data) => data
  })
};
